import api from './api';

const ENDPOINT = 'exchanges';

const ExchangeService = {
  get: () => api.get(`${ENDPOINT}`),
};

export default ExchangeService;
